import round from 'lodash/round';

import { useLocalization } from '~src/hooks';
import { SolarPanel } from '~src/types';

import { ProductCard, ProductCardProps } from './ProductCard';
import { getProductDimensionString } from './productCardHelper';

type SolarPanelProductCardProps = Pick<ProductCardProps, 'onSelect' | 'selected' | 'preferred' | 'type'> & {
  product: SolarPanel;
  showNotes?: boolean;
};

export const SolarPanelProductCard = ({
  onSelect,
  product,
  selected,
  preferred,
  type,
  showNotes,
}: SolarPanelProductCardProps) => {
  const translate = useLocalization();

  const { weight, capacity, annualProduction, notes } = product;

  return (
    <ProductCard
      attributes={[
        { name: translate.WEIGHT, value: `${round(weight, 0)} kg` },
        { name: translate.CAPACITY, value: `${round(capacity, 0)} kWp` },
        getProductDimensionString(product.size, translate),
      ]}
      brand={product.brand}
      id={product.id}
      imageUrl={product.imageUrl ?? undefined}
      model={product.model}
      onSelect={onSelect}
      preferred={preferred}
      price={product.price}
      selected={selected}
      subtitle={`${translate.ANNUAL_PRODUCTION} ${round(annualProduction, 0)} kWh`}
      type={type}
      notes={showNotes ? notes : undefined}
    />
  );
};
